import Vue from 'vue'
import {
  fb, db, indexOf, removeObjectFromArray
} from '@/components/common.js'

export default {
  notFound: (state, value) => (state.notFound = value),
  enqueueAsync: (state) => state.asyncQueue.push(true),
  dequeueAsync: (state) => state.asyncQueue.shift(),
  enqueueAddPage: (state, page) => state.addPageQueue.push(page),
  dequeueAddPage: state => state.addPageQueue.shift(),
  enqueueCallback: (state, callback) => state.callbacks.push(callback),
  dequeueCallback: state => {
    if (state.callbacks.length) {
      state.callbacks.shift()()
    }
  },
  anonymousOn: state => (state.anonymous = true),
  anonymousOff: state => (state.anonymous = false),
  signInAnonymous: state => (state.signInAnonymous = true),
  disablePageCreate: (state, value) => (state.disablePageCreate = value),
  storeMembers: (state, members) => (state.members = members),
  updateWishlistQuantity: (state, params) => {
    const name = params.name
    if (params.method === 'increment') {
      state[name].items[params.index].quantity = Math.min(
        state[name].items[params.index].quantity + 1, 99
      )
    } else if (params.method === 'decrement') {
      state[name].items[params.index].quantity = Math.max(
        state[name].items[params.index].quantity - 1, 0
      )
    } else {
      state[name].items[params.index].quantity = params.quantity
    }
    if (name === 'wishlist') {
      state.wishlistOperationCounter++
    }
  },
  signOut: state => (state.user = {}),
  setMypageCurrentList: (state, n) => (state.mypageCurrentList = n),
  storeCacheImage: (state, image) => {
    Vue.set(state.cache.images, image.fullPath, {source: image.source})
  },
  changePageMainComponent: (state, name) => (state.pageMainComponent = name),
  storeOrder: (state, order) => {
    state.order = order
  },
  storeUser (state, user) {
    user.wishlists = user.wishlists || []
    user.histories = user.histories || []
    user.receipts = user.receipts || []
    state.user = user
    Vue.set(state.users, user.uid, user)
  },
  storeProviderData (state, user) {
    state.providerData = user
    if (user.isAnonymous) {
      localStorage.uid = user.uid
    }
  },
  storeUsers (state, user) {
    Vue.set(state.users, user.uid, user)
  },
  enqueueHistories (state, page) {
    const history = {
      created: new Date(),
      dates: page.dates,
      id: page.id,
      images: page.images,
      title: page.title,
      pages_ref: db.doc('pages/' + page.id)
    }
    if (!page.r18 || sessionStorage.r18) {
      state.historiesQueue.push(history)
    }
  },
  dequeueHistories (state) {
    if (!state.historiesQueue.length) {
      return false
    }
    state.historiesQueue.shift()
  },
  storeUserHistories (state, histories) {
    state.user.histories = histories
  },
  enqueueError: (state, error) => state.errorQueue.push(error),
  dequeueError: state => state.errorQueue.shift(),
  removeCache (state, keys) {
    Vue.delete(state.cache[keys[0]], keys[1])
  },
  storePage (state, page) {
    page.r18 = page.items.some(item => item.r18)
    state.page = page
    Vue.set(state.cache.pages, page.id, page)
  },
  discardPage (state) {
    state.page = {
      items: [],
      images: [{}, {}]
    }
    state.tempPage = {
      items: [],
      images: [{}, {}],
      links: [{}]
    }
    state.members = []
  },
  discardOrder (state) {
    state.order = {}
  },
  storeTempPage (state, page) {
    state.tempPage = page
  },
  clearTempPage (state) {
    state.tempPage = {
      title: '',
      description: '',
      items: [],
      images: [{}, {}],
      links: [{}]
    }
  },
  updateUserWishlists: (state, wishlists) => {
    state.user.wishlists = wishlists
    db.doc('users/' + state.user.uid + '/private/1').update({
      wishlists,
      modified: fb.firestore.FieldValue.serverTimestamp()
    })
      .catch(error => state.errorQueue.push(error))
  },
  storeWishlist: (state, wishlist) => {
    if (state.page.id === wishlist.pages_ref.id) {
      /*
        * 差分を追加。pagesから削除されたwishlistのitemも残す
        */
      const items = state.page.items.map(item => {
        return wishlist.items[indexOf(wishlist.items, 'id', item.id)] || {
          id: item.id,
          price: item.price,
          quantity: 0
        }
      })
      wishlist.items = items
    }
    state.wishlist = wishlist
    Vue.set(state.cache.wishlists, wishlist.id, wishlist)
  },
  storeReceipt: (state, receipt) => {
    Vue.set(state.receipts, receipt.id, receipt)
  },
  storeReceipts: (state, receipts) => {
    receipts.forEach(receipt => {
      receipt.amount = receipt.items.reduce((a, b) => {
        return a + b.price.value * b.quantity
      }, 0)
      Vue.set(state.receipts, receipt.id, receipt)
      removeObjectFromArray(state.user.wishlists, 'page_id', receipt.page_id)
    })
    receipts = receipts.map(receipt => {
      return {
        id: receipt.id,
        title: receipt.title,
        dates: receipt.dates,
        images: receipt.images,
        created: receipt.created,
        page_id: receipt.page_id,
        pages_ref: receipt.pages_ref,
        amount: receipt.amount
      }
    })
    state.user.receipts.push(...receipts)
    state.user.receipts = state.user.receipts.filter((item, i, array) => {
      return indexOf(array, 'id', item.id) === i
    })
    /**
     * 重複排除
     */
    db.doc('users/' + state.user.uid + '/private/1').update({
      wishlists: state.user.wishlists,
      receipts: state.user.receipts,
      modified: fb.firestore.FieldValue.serverTimestamp()
    })
      .catch(error => state.errorQueue.push(error))
  },
  enqueueRoute: (state, route) => {
    Vue.set(state.routes, 0, route)
  },
  dequeueRoute: (state) => state.routes.shift(),
  initializeWishlist (state) {
    state.wishlist = {
      page_id: state.page.id,
      users_ref: db.doc('users/' + state.user.uid),
      pages_ref: db.doc('pages/' + state.page.id),
      items: state.page.items.map(item => {
        return {
          id: item.id,
          price: item.price,
          quantity: 0
        }
      })
    }
  },
  updatePageItems (state, items) {
    state.page.items = items
  },
  storeImagePosition: (state, position) => (state.imagePosition = position),
  enqueueImageSource: (state, image) => {
    image.position = state.imagePosition
    state.imageSourceQueue.push(image)
  },
  /*
    * index指定する必要がある？？？
    */
  dequeueImageSource: (state) => state.imageSourceQueue.shift(),
  pageNotFound (state) {
    state.page = {
      title: '404 Not Found',
      images: [{}, {}],
      items: [],
      dates: []
    }
  },
  initializeSales: (state, pageId) => {
    if (!state.sales[pageId]) {
      Vue.set(state.sales, pageId, {
        recent: null,
        current: null,
        histories: {}
      })
    }
  },
  storeSales: (state, params) => {
    const hc = params.history.created

    if (state.sales[params.pageId].current) {
      const cc = state.sales[params.pageId].current.created
      state.sales[params.pageId].current =
        cc.seconds + '.' + cc.nanoseconds < hc.seconds + '.' + hc.nanoseconds
          ? state.sales[params.pageId].current
          : params.history
    } else {
      state.sales[params.pageId].current = params.history
    }

    if (state.sales[params.pageId].recent) {
      const rc = state.sales[params.pageId].recent.created
      state.sales[params.pageId].recent =
        rc.seconds + '.' + rc.nanoseconds > hc.seconds + '.' + hc.nanoseconds
          ? state.sales[params.pageId].recent
          : params.history
    } else {
      state.sales[params.pageId].recent = params.history
    }

    params.history.total = {
      quantity: params.history.items.reduce((a, b) => a + b.quantity, 0),
      price: {value: params.history.items.reduce((a, b) => a + b.price.value * b.quantity, 0)}
    }
    Vue.set(state.sales[params.pageId].histories, params.history.id, params.history)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js